import type { SerializedTemplate, Template } from '@enmon/commons/lib/tools';
import type { BaseAPIParams } from 'lib/utils/BaseAPIParams';
import { BASE_REST_API_URL } from 'common/constants';
import type { UploadFile } from 'antd/lib/upload/interface';
import { BaseApiClient } from './baseApiClient';

export type TemplatesFilter = BaseAPIParams<SerializedTemplate> & {
  reseller?: string;
};

/**
 * @deprecated Use class instead because there is only one implementation of this interface which makes searching for references
 * more difficult, name shouldn't be prefixed too: https://blog.nette.org/en/prefixes-and-suffixes-do-not-belong-in-interface-names.
 */
export interface ITemplatesApiClient {
  upload(file: UploadFile): Promise<{ status: 'OK' }>;
  delete(id: Template['id']): Promise<void>;
}

export class TemplatesApiClient extends BaseApiClient implements ITemplatesApiClient {
  constructor(jwt: string) {
    super('templates', BASE_REST_API_URL, jwt);
  }

  public async upload(file: UploadFile): Promise<{ status: 'OK' }> {
    const formData = new FormData();
    formData.append('files.file', file.originFileObj);

    // data is required to be in the body of the multipart request
    const JSONForm = JSON.stringify({});
    formData.append('data', JSONForm);

    const response = await this.axios.post<{ status: 'OK' }>('upload', formData);

    return response.data;
  }

  public async delete(id: Template['id']): Promise<void> {
    await this.axios.delete<void>(id.toString());
  }
}
